import * as types from '../../actions/actionsTypes/authenticationActionTypes';
import {printOnlyInDevelopment} from "../../fanctionUtility";
import new_axios_instance from "../../axios_instance";

export const initialStateAuthentication = {
    token: null,
    refreshToken: null,
    exp: null,
    user: null,
    profiliDisponibili: [],
    ruoloScelto: null,
    errori: null
};

export const authenticationReducer = (state = initialStateAuthentication, action) => {
    switch (action.type) {
        case types.RECUPERA_GENERALITA : {
            return {
                ...state,
                user: {
                    USER_CF: action.user.preferred_username.split('-')[1].toUpperCase(),
                    USER_NAME: action.user.given_name,
                    USER_SURNAME: action.user.family_name,
                }
            }
        }

        case types.GET_TOKEN : {
            new_axios_instance.defaults.headers.common['Authorization'] = `${action.token.token_type} ${action.token.access_token}`;
            return {
                ...state,
                token: action.token.access_token,
                refreshToken: action.token.refresh_token,
                exp: action.token.expires_in
            }
        }

        case types.SET_TOKEN_REFRESH : {
            return {
                ...state,
                token: action.tokenData
            }
        }

        case types.RECUPERA_PROFILI_SUCCESS : {
            return {
                ...state,
                profiliDisponibili: action.profiliDisponibili,
                errori: null
            }
        }

        case types.RECUPERA_PROFILI_FAIL : {
            return {
                ...state,
                profiliDisponibili: [],
                ruoloScelto: null,
                errori: action.error
            }
        }

        case types.SALVA_RUOLO_SCELTO : {
            new_axios_instance.defaults.headers.common['Ruolo'] = action.ruolo;
            return {
                ...state,
                ruoloScelto: action.ruolo,
                errori: null
            }
        }

        case types.INIT_AUTH : {
            return {
                appCode: null,
                authCode: null,
                token: null,
                exp: null,
                user: null,
                profiliDisponibili: [],
                ruoloScelto: null,
                errori: null
            };
        }

        case types.CLEAR_ERROR : {
            return {
                ...state,
                errori: null
            }
        }

        default : {
            return state;
        }
    }
};

